(function () {
    'use strict';

    angular
        .module('app')
        .controller('ContractsAddController', ContractsAddController);

    ContractsAddController.$inject = ['debug', '$stateParams', 'API', '$state', 'i18n',];

    function ContractsAddController(debug, $stateParams, API, $state, i18n) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.isAdding = false;
        vm.add = add;
        vm.contract = {
            fk_type_id: 20,
            product: 'play',
            status: 'active'
        };
        vm.loadingState = {
            'contractTypesIsLoading': false
        };
        vm.connectToSchoolWithId = 0;
        vm.connectToSchoolName = '';

        activate();

        function activate() {
            if ($stateParams.schoolId) {
                vm.connectToSchoolWithId = $stateParams.schoolId;
            }
            if ($stateParams.schoolName) {
                vm.connectToSchoolName = $stateParams.schoolName;
            }

            loadContractTypes();
        }

        function loadContractTypes() {
            vm.loadingState.contractTypesIsLoading = true;
            API.ContractType.get().$promise.then(function (response) {
                vm.contractTypes = response.items;
                vm.loadingState.contractTypesIsLoading = false;
            }, function (response) {
                debug.error('Kontrakttyper kunde inte laddas in. Kontakta utvecklare.', response);
            });
        }

        // Define public variables and methods

        function add() {
            if (!vm.isAdding || !vm.loadingState.contractTypesIsLoading) {
                vm.isAdding = true;

                var newContract = new API.Contract(vm.contract);

                var promise = newContract.$save();

                promise.then(function (response) {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });

                    if (vm.connectToSchoolWithId) {
                        var connectSchoolPromise = API.Contract.connectSchool({
                            id: response.id,
                            schoolId: vm.connectToSchoolWithId
                        }).$promise;

                        connectSchoolPromise.then(function() {
                            window.toast({ message: i18n.get('CONNECTED_CONTRACT_TO_SCHOOL'), autoRemoveTime: 5000, type: 'success' });
                            $state.go('schools.edit', { id: vm.connectToSchoolWithId });
                        }, function() {
                            window.toast({ message: i18n.get('COULD_NOT_CONNECT_CONTRACT_TO_SCHOOL'), autoRemoveTime: 5000, type: 'danger' });
                            $state.go('schools.edit', { id: vm.connectToSchoolWithId });
                        })
                        .finally(function() {
                            vm.isAdding = false;
                        });
                    } else {
                        window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                        $state.go('contracts.edit', { id: response.id });
                    }
                }, function (response) {
                    debug.log(response);
                    vm.isAdding = false;
                });

            }
            }
        }
    }
)();